// React
import React from 'react';
// Components
import CustomStateBlock from '../custom-state-block';

const CustomEmptyStateBlock = React.memo(({ classes, text }) => {
  return <CustomStateBlock text={text} />;
});

CustomEmptyStateBlock.defaultProps = {
  classes: {},
  text: null,
};

export default CustomEmptyStateBlock;
